// @flow
import React from 'react';
import styled from 'styled-components';

import { useIsCE2 } from '../../custom-hooks/useIsCE2';

import { LineBreak } from './spacing/LineBreak';

const StyledBanner = styled.div`
  background-color: #d32f2f;
  color: #ffffff;
  text-align: center;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

export const CE2DeprecationBanner = () => {
  const isCE2 = useIsCE2();

  if (!isCE2) {
    return null;
  }

  return (
    <StyledBanner>
      Integrated Cloud Estimator (CE2) is being deprecated and now supports only Baseline Import
      temporarily until the feature is available in Commit Estimator (CE1).
      <LineBreak />
      Please move all estimate creation and in-flight estimates to CE1, as push to SFDC no longer
      works in CE2. All other features, including eCKU and CFU packages, are available in CE1.
    </StyledBanner>
  );
};
